module.exports = __webpack_public_path__ + "img/pos5_s1.76a6f49e.png";